










export default {
  name: 'Body',
  props: {
    slotComponent: {},
    slotProps: {},
    text: {
      type: String,
    },
  },
  methods: {

  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppModal/components/Body.vue